// extracted by mini-css-extract-plugin
export var columnList = "_am-0";